import { useState } from 'react';
import { EmployeeProvider, useEmployee } from './EmployeeContext';
import { ConsentScreen } from './onboarding/ConsentScreen';
import { useSession } from '../../context/SessionContext';
import { ModalProvider } from '../../components/ModalProvider';
import { ThemeToggle } from '../../components/ThemeToggle';
import { PontoTab } from './PontoTab';
import { AlimentacaoTab } from './AlimentacaoTab';
import { RecebimentosTab } from './RecebimentosTab';
import { DocumentosTab } from './DocumentosTab';
import { ContaTab } from './ContaTab';
import { NotificationNudge } from './NotificationNudge';
import { TrocarSenhaNudge } from './TrocarSenhaNudge';
import { SosButton } from './SosButton';

type EmpTab = 'ponto' | 'alim' | 'recv' | 'docs' | 'conta';

function EmployeeInner() {
  const { employee, consent } = useEmployee();
  const { logout } = useSession();
  const [tab, setTab] = useState<EmpTab>('ponto');

  if (!consent) return <ConsentScreen />;

  return (
    <>
      <div className="brand">
        <div className="stamp-mark"><span>C</span></div>
        <div>
          <div className="brand-name" style={{ fontSize: 17 }}>{employee.nome}</div>
          <div className="brand-sub">{employee.funcao} · {employee.camarote}</div>
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}><ThemeToggle /><button className="btn btn-ghost btn-sm" onClick={logout}>Sair</button></div>
      </div>

      <NotificationNudge />
      <TrocarSenhaNudge />
      <SosButton />

      {tab === 'ponto' && <PontoTab />}
      {tab === 'alim' && <AlimentacaoTab />}
      {tab === 'recv' && <RecebimentosTab />}
      {tab === 'docs' && <DocumentosTab />}
      {tab === 'conta' && <ContaTab />}

      <div className="tabbar"><div className="tabbar-inner">
        <button className={`tab-btn ${tab === 'ponto' ? 'active' : ''}`} onClick={() => setTab('ponto')}><span className="ic">⏱</span>Ponto</button>
        <button className={`tab-btn ${tab === 'alim' ? 'active' : ''}`} onClick={() => setTab('alim')}><span className="ic">🍽</span>Alimentação</button>
        <button className={`tab-btn ${tab === 'recv' ? 'active' : ''}`} onClick={() => setTab('recv')}><span className="ic">📦</span>Recebimentos</button>
        <button className={`tab-btn ${tab === 'docs' ? 'active' : ''}`} onClick={() => setTab('docs')}><span className="ic">✎</span>Documentos</button>
        <button className={`tab-btn ${tab === 'conta' ? 'active' : ''}`} onClick={() => setTab('conta')}><span className="ic">👤</span>Minha conta</button>
      </div></div>
    </>
  );
}

export function EmployeeShell() {
  return (
    <EmployeeProvider>
      {/* ModalProvider aninhado aqui (e não só no topo do app) para que os
          modais dos fluxos do funcionário (assinatura, foto do documento,
          consentimento etc.) renderizem DENTRO da árvore do EmployeeProvider
          e consigam usar useEmployee() sem quebrar. */}
      <ModalProvider>
        <EmployeeInner />
      </ModalProvider>
    </EmployeeProvider>
  );
}
